import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { EmployeeService } from '../../../services/index';

@Component({
    selector: 'add-edit-employee-window',
    templateUrl: './addEditEmployee.component.html'
})
export class AddEditEmployeeComponent implements OnInit {
    public title: string;
    public mode: string;
    public employeedata: any = {};

    genderList: any = ['MALE', 'FEMALE'];
    maritalStatusList: any = ['SINGLE', 'MARRIED'];
    statusList: any = ['Active', 'Inactive'];

    // trigger-variable for Ladda
    isLoading: boolean = false;
    @Output() employeeLoadEvent = new EventEmitter();

    constructor(
        private employeeService: EmployeeService,
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        setTimeout(() => {
            $('#empcode').focus();
        }, 100);
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onSaveEmployee(): void {
        let that = this;
        this.isLoading = true;

        // Convert empname to uppercase
        if (this.employeedata['empname']) {
            this.employeedata['empname'] = this.employeedata['empname'].toUpperCase();
        }

        // Convert fatherguardianname to uppercase
        if (this.employeedata['fatherguardianname']) {
            this.employeedata['fatherguardianname'] = this.employeedata['fatherguardianname'].toUpperCase();
        }

        this.employeeService
            .addUpdateEmployee(this.employeedata)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.employeeLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/employee/addEditEmployee.component.ts